// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Uq-z","breadcrumbForward":"Vq-z","breadcrumbBack":"Wq-z","selected":"Xq-z"};